import type { Exercise, ExerciseId } from '@/domain/exercise'

/**
 * Catálogo de movimientos. Todos son sin material: lo único que hace falta
 * es un hueco del tamaño de una esterilla.
 */
export const EXERCISES = {
  jumping_jacks: {
    id: 'jumping_jacks',
    name: 'Jumping Jacks',
    nameEs: 'Saltos de tijera',
    cue: 'Brazos y piernas se abren a la vez. Ritmo constante.',
  },
  skippings: {
    id: 'skippings',
    name: 'Skippings',
    nameEs: 'Rodillas al pecho',
    cue: 'Rodillas altas, apoyo con la punta del pie.',
  },
  air_squats: {
    id: 'air_squats',
    name: 'Air Squats',
    nameEs: 'Sentadilla al aire',
    cue: 'Baja hasta que la cadera pase por debajo de la rodilla. Pecho alto, talones en el suelo.',
  },
  shoulder_taps: {
    id: 'shoulder_taps',
    name: 'Shoulder Taps',
    nameEs: 'Toque de hombro',
    cue: 'En plancha. Cadera quieta, alternando el brazo que toca el hombro contrario.',
  },
  push_ups: {
    id: 'push_ups',
    name: 'Push Ups',
    nameEs: 'Flexiones',
    cue: 'Codos pegados al cuerpo, apuntando atrás. Pecho al suelo. Fácil: apoya las rodillas.',
  },
  lunges: {
    id: 'lunges',
    name: 'Lunges',
    nameEs: 'Zancadas alternas',
    cue: 'Baja hasta que la rodilla de atrás casi toque el suelo. 6 por pierna.',
  },
  mountain_climbers: {
    id: 'mountain_climbers',
    name: 'Mountain Climbers',
    nameEs: 'Escaladores',
    cue: 'Plancha firme, rodillas al pecho alternando. 10 por pierna.',
  },
  sit_ups: {
    id: 'sit_ups',
    name: 'Sit Ups',
    nameEs: 'Abdominales',
    cue: 'Sube hasta tocar los pies, baja con control.',
  },
  burpees: {
    id: 'burpees',
    name: 'Burpees',
    nameEs: 'Burpees',
    cue: 'Pecho al suelo del todo, y salto arriba con palmada por encima de la cabeza.',
  },
  squat_jump: {
    id: 'squat_jump',
    name: 'Squat Jumps',
    nameEs: 'Sentadilla con salto',
    cue: 'Baja a sentadilla y sube saltando. Aterriza suave, rodilla flexionada. Fácil: sube a puntillas sin despegar.',
  },
  pike_push_ups: {
    id: 'pike_push_ups',
    name: 'Pike Push Ups',
    nameEs: 'Flexión pike',
    cue: 'Caderas altas, cabeza hacia el suelo entre las manos. Fácil: manos elevadas en un banco.',
  },
  glute_bridge: {
    id: 'glute_bridge',
    name: 'Glute Bridge',
    nameEs: 'Puente de glúteo',
    cue: 'Tumbado boca arriba, pies apoyados. Sube la cadera apretando el glúteo y aguanta arriba un segundo.',
  },
  bicycle_crunch: {
    id: 'bicycle_crunch',
    name: 'Bicycle Crunch',
    nameEs: 'Bicicleta',
    cue: 'Tumbado, codo hacia la rodilla contraria alternando. Lento y controlado, no a tirones.',
  },
  skaters: {
    id: 'skaters',
    name: 'Skaters',
    nameEs: 'Patinador',
    cue: 'Salto lateral de un pie al otro, la pierna de atrás cruza. Fácil: paso lateral sin salto.',
  },
  tricep_dips: {
    id: 'tricep_dips',
    name: 'Tricep Dips',
    nameEs: 'Fondos de tríceps',
    cue: 'Manos en un banco o escalón detrás de ti. Baja doblando los codos hacia atrás, nunca hacia fuera.',
  },
  inchworm: {
    id: 'inchworm',
    name: 'Inchworm',
    nameEs: 'Oruga',
    cue: 'De pie, baja las manos al suelo y camina con ellas hasta la plancha. Pecho al suelo y vuelve caminando con las manos hasta ponerte de pie.',
  },
  superman: {
    id: 'superman',
    name: 'Superman',
    nameEs: 'Superman',
    cue: 'Boca abajo, sube pecho, brazos y piernas a la vez. Aguanta arriba un segundo.',
  },
  leg_raises: {
    id: 'leg_raises',
    name: 'Leg Raises',
    nameEs: 'Elevación de piernas',
    cue: 'Tumbado boca arriba, piernas rectas suben y bajan sin tocar el suelo. Zona lumbar pegada.',
  },
  side_plank_dip: {
    id: 'side_plank_dip',
    name: 'Side Plank Dips',
    nameEs: 'Plancha lateral con caída',
    cue: 'En plancha lateral, baja la cadera hasta casi tocar y vuelve a subir. Mitad por cada lado.',
  },
  plank: {
    id: 'plank',
    name: 'Plank',
    nameEs: 'Plancha',
    cue: 'Antebrazos y puntas de los pies. Cuerpo en línea recta: ni cadera alta ni riñones hundidos. Aprieta glúteo y abdomen.',
  },
  wall_sit: {
    id: 'wall_sit',
    name: 'Wall Sit',
    nameEs: 'Sentadilla en pared',
    cue: 'Espalda pegada a la pared, rodillas a 90°. Aguanta sin apoyar las manos en los muslos.',
  },
  reverse_lunges: {
    id: 'reverse_lunges',
    name: 'Reverse Lunges',
    nameEs: 'Zancada hacia atrás',
    cue: 'El paso va hacia atrás, no hacia delante. Perdona más la rodilla. 6 por pierna.',
  },
  high_knees: {
    id: 'high_knees',
    name: 'High Knees',
    nameEs: 'Rodillas arriba',
    cue: 'Rodilla por encima de la cadera, apoyo con la punta del pie. Fácil: sin salto, marcando el paso.',
  },
  bear_crawl: {
    id: 'bear_crawl',
    name: 'Bear Crawl',
    nameEs: 'Marcha del oso',
    cue: 'A cuatro apoyos con las rodillas a un palmo del suelo. Avanza mano y pie contrarios, cadera quieta.',
  },
  hollow_hold: {
    id: 'hollow_hold',
    name: 'Hollow Hold',
    nameEs: 'Barquita',
    cue: 'Boca arriba, brazos y piernas estirados y despegados. La lumbar no se separa del suelo. Fácil: rodillas dobladas.',
  },
  broad_jumps: {
    id: 'broad_jumps',
    name: 'Broad Jumps',
    nameEs: 'Salto horizontal',
    cue: 'Salta hacia delante con los dos pies y aterriza en sentadilla. Vuelve andando al sitio.',
  },
  single_leg_glute_bridge: {
    id: 'single_leg_glute_bridge',
    name: 'Single Leg Glute Bridge',
    nameEs: 'Puente de glúteo a una pierna',
    cue: 'Puente con una pierna estirada al aire. La cadera sube recta, sin caerse de lado. Mitad por cada pierna.',
  },
  cossack_squat: {
    id: 'cossack_squat',
    name: 'Cossack Squat',
    nameEs: 'Sentadilla cosaca',
    cue: 'Pies muy abiertos. Baja sobre una pierna dejando la otra estirada. Fácil: no bajes del todo.',
  },
  push_up_down_dog: {
    id: 'push_up_down_dog',
    name: 'Push Up to Down Dog',
    nameEs: 'Flexión a perro boca abajo',
    cue: 'Una flexión y, al subir, lleva la cadera arriba y atrás estirando la espalda. Fácil: flexión con rodillas apoyadas.',
  },
} as const satisfies Record<string, Exercise>

export type KnownExerciseId = keyof typeof EXERCISES

const FALLBACK: Exercise = {
  id: 'desconocido',
  name: 'Ejercicio',
  nameEs: '',
  cue: '',
}

/**
 * Catálogo que llega con el reto publicado. Manda sobre el de arriba: permite
 * añadir o corregir ejercicios desde el panel sin recompilar la app.
 */
let published: Record<string, Exercise> = {}

export function setPublishedExercises(catalog: Record<string, Exercise>): void {
  published = catalog
}

/** Nunca revienta: si el id no existe, devuelve un hueco con nombre genérico. */
export function getExercise(id: ExerciseId): Exercise {
  return published[id] ?? (EXERCISES as Record<string, Exercise>)[id] ?? { ...FALLBACK, id }
}
